/* eslint-disable react/jsx-props-no-spreading */

import { ReactNode } from 'react';
import { Link, To, useLocation } from 'react-router-dom';

interface I_LinkWithQuery {
  children: ReactNode;
  to: To;
}

function LinkWithQuery({ children, to, ...props }: I_LinkWithQuery) {
  const { search } = useLocation();

  return (
    <Link to={to + search} {...props}>
      {children}
    </Link>
  );
}

export default LinkWithQuery;
